import type { Template } from "@/types";

export const LA_04_H3_V1: Template[] = [
    {
        id: "la-04-h3v1-01",
        name: "LA 01 - H3V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h3_v1_01.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 193, y: 37, width: 289, height: 410, rotation: 0, imageRotation: 0 },
            { id: "2", x: 905, y: 37, width: 218, height: 132, rotation: 0, imageRotation: 0 },
            { id: "3", x: 905, y: 177, width: 218, height: 131, rotation: 0, imageRotation: 0 },
            { id: "4", x: 905, y: 316, width: 218, height: 131, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h3v1-02",
        name: "LA 02 - H3V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h3_v1_02.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 193, y: 35, width: 289, height: 413, rotation: 0, imageRotation: 0 },
            { id: "2", x: 781, y: 204, width: 466, height: 243, rotation: 0, imageRotation: 0 },
            { id: "3", x: 781, y: 36, width: 230, height: 161, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1018, y: 36, width: 229, height: 161, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h3v1-03",
        name: "LA 03 - H3V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h3_v1_03.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 38, y: 36, width: 289, height: 410, rotation: 0, imageRotation: 0 },
            { id: "2", x: 1096, y: 36, width: 218, height: 132, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1096, y: 176, width: 218, height: 131, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1096, y: 315, width: 218, height: 131, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h3v1-04",
        name: "LA 04 - H3V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h3_v1_04.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 129, y: 37, width: 419, height: 264, rotation: 0, imageRotation: 0 },
            { id: "2", x: 129, y: 308, width: 206, height: 137, rotation: 0, imageRotation: 0 },
            { id: "3", x: 342, y: 308, width: 206, height: 137, rotation: 0, imageRotation: 0 },
            { id: "4", x: 866, y: 37, width: 297, height: 408, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h3v1-5",
        name: "LA 05 - H3V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h3_v1_05.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 83, y: 66, width: 510, height: 353, rotation: 0, imageRotation: 0 },
            { id: "2", x: 750, y: 66, width: 272, height: 173, rotation: 0, imageRotation: 0 },
            { id: "3", x: 750, y: 246, width: 272, height: 172, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1030, y: 66, width: 251, height: 353, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h3v1-06",
        name: "LA 06 - H3V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h3_v1_06.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 190, width: 383, height: 253, rotation: 0, imageRotation: 0 },
            { id: "2", x: 390, y: 190, width: 383, height: 253, rotation: 0, imageRotation: 0 },
            { id: "3", x: 781, y: 190, width: 184, height: 253, rotation: 0, imageRotation: 0 },
            { id: "4", x: 972, y: 190, width: 386, height: 253, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h3v1-07",
        name: "LA 07 - H3V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h3_v1_07.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 67, y: 119, width: 343, height: 246, rotation: 0, imageRotation: 0 },
            { id: "2", x: 418, y: 119, width: 343, height: 246, rotation: 0, imageRotation: 0 },
            { id: "3", x: 768, y: 119, width: 343, height: 246, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1119, y: 119, width: 167, height: 246, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h3v1-08",
        name: "LA 08 - H3V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h3_v1_08.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 39, y: 32, width: 312, height: 206, rotation: 0, imageRotation: 0 },
            { id: "2", x: 39, y: 246, width: 312, height: 205, rotation: 0, imageRotation: 0 },
            { id: "3", x: 358, y: 32, width: 649, height: 419, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1014, y: 32, width: 299, height: 419, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h3v1-09",
        name: "LA 09 - H3V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h3_v1_09.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 39, y: 32, width: 312, height: 206, rotation: 0, imageRotation: 0 },
            { id: "2", x: 39, y: 246, width: 312, height: 205, rotation: 0, imageRotation: 0 },
            { id: "3", x: 358, y: 32, width: 299, height: 419, rotation: 0, imageRotation: 0 },
            { id: "4", x: 665, y: 32, width: 649, height: 419, rotation: 0, imageRotation: 0 }        
        ],
    },

    {
        id: "la-04-h3v1-10",
        name: "LA 10 - H3V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h3_v1_10.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 31, width: 339, height: 206, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 245, width: 339, height: 206, rotation: 0, imageRotation: 0 },
            { id: "3", x: 347, y: 31, width: 705, height: 420, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1060, y: 31, width: 292, height: 420, rotation: 0, imageRotation: 0 }
        ],
    }
];
